import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEs from "./locales/es/translation.json";
import translationFr from "./locales/fr/translation.json";

const resources = {
  es: { translation: translationEs },
  fr: { translation: translationFr },
  // "en" has no file — keys are English so i18n shows them as-is (correct behaviour)
};

// Read language persisted by useLanguageChange, default to French
const savedLng = localStorage.getItem("app_language") || "fr";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLng,
    fallbackLng: "fr",   // French is the real fallback (no English resource file)
    keySeparator: false,
    interpolation: { escapeValue: false },
  });

export default i18n;
